module.exports = __webpack_public_path__ + "media/images/favicon-eacfded2d0d831bd419e2b0a16a24325.png";